import { faTrashAlt } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { RoomRule } from '@spike/room-model';
import clsx from 'clsx';
import DescriptionText from 'components/UI/V3/DescriptionText';
import { Label } from 'components/UI/V3/Forms/Label/Label';
import NumberField from 'components/UI/V3/Forms/NumberField';
import { FunctionComponent } from 'react';
import styles from './WeightRangeRule.module.scss';
import CounterField from 'components/UI/V3/CounterField/CounterField';

interface WeightRangeRuleProps {
    rule: RoomRule;
    onChange: (rule: RoomRule) => void;
    onDelete?: () => void;
    className?: string;
    error?: string;
}

export const WeightRangeRule: FunctionComponent<WeightRangeRuleProps> = props => {
    return (
        <div className={clsx(styles.container, props.className)}>
            <div className={styles.row}>
                <Label>Rule – By Weight Range</Label>
                <FontAwesomeIcon
                    icon={faTrashAlt}
                    onClick={props.onDelete}
                    className={styles.deleteIcon}
                />
            </div>
            <DescriptionText
                className={styles.description}
                text="Set the total number of pets allowed in this room within the selected weight range."
            />
            <div className={styles.weightRange}>
                <CounterField
                    value={JSON.parse(props.rule.data).quantity}
                    onChange={quantity =>
                        quantity && props.onChange({ ...props.rule, data: JSON.stringify({ quantity }) })
                    }
                    minLimit={1}
                    maxLimit={999}
                    hasBorder={true}
                    className={styles.counterField}
                />
                <div className={styles.weightRangeItems}>
                    <div className={styles.weightRangeItem}>
                        <Label className={styles.weightLabel}>From</Label>
                        <div className={styles.weight}>
                            <NumberField
                                endIcon={<span className={styles.lbs}>Lbs</span>}
                                value={JSON.parse(props.rule.data).weightFrom}
                                onChange={value =>
                                    props.onChange({
                                        ...props.rule,
                                        data: JSON.stringify({ ...JSON.parse(props.rule.data), weightFrom: value })
                                    })
                                }
                                placeholder="Ex. 15"
                                precision={4}
                                className={styles.numberField}
                            />
                        </div>
                    </div>
                    <span className={styles.weightRangeSeparator}>-</span>
                    <div className={styles.weightRangeItem}>
                        <Label className={styles.weightLabel}>To</Label>
                        <div className={styles.weight}>
                            <NumberField
                                endIcon={<span className={styles.lbs}>Lbs</span>}
                                value={JSON.parse(props.rule.data).weightTo}
                                onChange={value =>
                                    props.onChange({
                                        ...props.rule,
                                        data: JSON.stringify({ ...JSON.parse(props.rule.data), weightTo: value })
                                    })
                                }
                                placeholder="Ex. 45"
                                precision={4}
                                className={styles.numberField}
                            />
                        </div>
                    </div>
                </div>
            </div>
            {props.error && <span className={styles.errorWarning}>{props.error}</span>}
        </div>
    );
};

export default WeightRangeRule;
